import React from 'react';
import {CheckCircleOutlined, CloseCircleOutlined, SyncOutlined} from '@ant-design/icons';
import {Tag} from 'antd';

export type tagType = 'published' | 'draft' | 'retired';

const tagDetails = {
  published: {
    color: '#006A63',
    borderColor: '#00504A',
    label: 'Published',
    icon: <CheckCircleOutlined />,
  },
  draft: {
    color: '#52C41A',
    borderColor: '#237804',
    label: 'Draft',
    icon: <SyncOutlined />,
  },
  retired: {
    color: '#FAAD14',
    borderColor: '#831218',
    label: 'Retired',
    icon: <CloseCircleOutlined />,
  },
};

export const ModelStatusTag: React.FC<{status: tagType}> = ({status}) => {
  // Handle undefined or invalid status
  if (!status || !tagDetails[status]) {
    return null;
  }

  const {color, borderColor, label, icon} = tagDetails[status];
  return (
    <Tag color={color} icon={icon} style={{borderColor, color: status === 'retired' ? '#000000' : '#ffffff'}}>
      {label}
    </Tag>
  );
};
